"use strict";

import jQuery from 'jquery';

/**
 * @classdesc
 * Layertree-Panel.
 *
 * @class
 * @extends gc.gis.widget.GCPanel
 * @memberof gc.gis.module.GCLayerTree
 * @author Anton Popov <a.popov@brain-scc.de>
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 * @param {gc.gis.module.GCLayerTree} options.module Modul-Instanz.
 */
gc.gis.module.GCLayerTree.Panel = function( options )
{
	gc.gis.assert.isSet( options );
	gc.gis.assert.isInstance( options.module, gc.gis.module.GCLayerTree );

	this.module = options.module;

	var options_widget = {
		className: 'gc-layertree',
		//target: '#gc_layertree',
		toolbar: new gc.gis.widget.GCWidgetGroup({
			items: this._createToolbarWidgets()
		})
	};
	gc.gis.widget.GCPanel.call( this, options_widget );

    this.layer_elements = [];
	this.element = this._render();

	this._initContent();
};
gc.gis.module.GCLayerTree.Panel.prototype = Object.create(gc.gis.widget.GCPanel.prototype);

/**
 * @protected
 * @method
 *
 * @return {gc.gis.widget.GCWidget[]}
 */
gc.gis.module.GCLayerTree.Panel.prototype._createToolbarWidgets = function()
{
	var self = this;

	var items = [
		new gc.gis.widget.GCMenu({
			label: 'Aktionen ...',
			className: 'btn btn-default',
			icon: 'toolbar-action-selectionmenu',
			badge: new gc.gis.widget.GCBadge({
				init: function() {
					var b = this;	// Achtung: this === GCBadge-Instanz

					self.module.un( gc.gis.module.GCLayerTreeEvent.TOGGLE_SELECTED, self );
					self.module.on( gc.gis.module.GCLayerTreeEvent.TOGGLE_SELECTED, self, function( evt ) {
						b.update();
					} );
					self.module.un( gc.gis.module.GCLayerTreeEvent.UPDATE_FINISHED, self );
					self.module.on( gc.gis.module.GCLayerTreeEvent.UPDATE_FINISHED, self, function(evt ) {
						b.update();
					} );
					b.update();
				},
				update: function() {
					this.clear();	// Achtung: this === GCBadge-Instanz
					var count = self.module.getSelectionCount();
					if( count > 0 )
					{
						this.element.html('<span class="gc-badge-value">'
							+ count
							+'</span><span class="gc-badge-unit">'+ (count > 1 ? 'Ebenen' : 'Ebene') + '</span>');
						this.element.removeClass('gc-empty gc-hidden');
					}
					else
					{
						this.element.addClass('gc-empty gc-hidden');
					}
				}
			}),
			items: [
				[
					new gc.gis.widget.GCItem({
						label: 'Auf Auswahl zoomen',
						action: new gc.gis.action.layer.ZoomToSelection({map: self.module.map})
					}),
					new gc.gis.widget.GCItem({
						label: 'Ausgewählte Ebenen gruppieren',
						action: new gc.gis.action.layer.GroupSelection({map: self.module.map})
					}),
					new gc.gis.widget.GCItem({
						label: 'Ausgewählte Ebenen entfernen',
						action: new gc.gis.action.layer.RemoveSelection({map: self.module.map})
					})
				],
				[
					new gc.gis.widget.GCItem({
						label: 'Alle Ebenen auswählen',
						click: function( evt ) {
							self.module.map.selectAll();
						}
					}),
					// new gc.gis.widget.GCItem({
					// 	label: 'Auswahl invertieren',
					// 	click: function( event ) {
					// 		gc.gis.iface.map.selectInverse();
					// 	}
					// }),
					new gc.gis.widget.GCItem({
						label: 'Auswahl aufheben',
						click: function( evt ) {
							self.module.map.selectNone();
						}
					})
				],
				[
					new gc.gis.widget.GCItem({
						label: 'Alle Ebenen aktivieren',
						action: new gc.gis.action.layer.SetVisibilityAllLayer({map: self.module.map, visible: true})
					}),
					new gc.gis.widget.GCItem({
						label: 'Alle Ebenen deaktivieren',
						action: new gc.gis.action.layer.SetVisibilityAllLayer({map: self.module.map, visible: false})
					}),
					new gc.gis.widget.GCItem({
						label: 'Alle Ebenen entfernen',
						action: new gc.gis.action.layer.RemoveAllLayer({map: self.module.map})
					}),
					new gc.gis.widget.GCItem({
						label: 'Alle deaktivierten Ebenen entfernen',
						action: new gc.gis.action.layer.RemoveUnvisibleLayer({map: self.module.map})
					})
				],
				[
					new gc.gis.widget.GCItem({
						label: 'Neue Gruppe erstellen',
						action: new gc.gis.action.layer.NewGroupLayer({map: self.module.map})
					})
				]
			]
		})
	];

	return items;
};

/**
 * Initialisiert den Panel-Content.
 *
 * @protected
 * @method
 */
gc.gis.module.GCLayerTree.Panel.prototype._initContent = function()
{
	// Meldung keine Ebene geladen
    this.empty_msg = jQuery('<p>', {
        'class': 'gc-empty',
        html: '<em>Keine Ebenen geladen</em>'
    });
	// Layerliste
	this.ul_layer = jQuery('<ul>', {
		'class': 'layertree gc-layertree-root gc-group-items'
	});

	this.element_content.append(this.ul_layer).append(this.empty_msg);
};

/**
 * Leert den gesamten Layerbaum.
 *
 * @method
 * @public
 */
gc.gis.module.GCLayerTree.Panel.prototype.clear = function()
{
    this.ul_layer.children().remove();
    this.layer_elements = [];
};

/**
 * Fügt einen Layer dem Layerbaum hinzu.
 *
 * @param {gc.gis.layer.GCAbstractLayer} layer
 */
gc.gis.module.GCLayerTree.Panel.prototype.addLayer = function(layer)
{
    this.module._fireEvent(gc.gis.module.GCLayerTreeEvent.UPDATE_STARTED, {});

    var element = this._renderLayer(layer, this._getLayerElement(layer.getParent()));
    this._addLayerElement(layer, element);
	this._initDragAndDrop();

    this.module._fireEvent(gc.gis.module.GCLayerTreeEvent.UPDATE_FINISHED, {});
};

/**
 * Entfernt einen Layer aus dem Layerbaum.
 *
 * @param {gc.gis.layer.GCAbstractLayer} layer
 */
gc.gis.module.GCLayerTree.Panel.prototype.removeLayer = function(layer)
{
    this.module._fireEvent(gc.gis.module.GCLayerTreeEvent.UPDATE_STARTED, {});

	var element = this._getLayerElement(layer);
	if (element)
	{
		var body_element = element.parent().parent();
        element.remove();

        this._removeLayerElement(layer);
	}

    this.module._fireEvent(gc.gis.module.GCLayerTreeEvent.UPDATE_FINISHED, {});
};

/**
 * Verschiebt einen Layer innerhalb des Layerbaums.
 *
 * @param {gc.gis.layer.GCAbstractLayer[]|gc.gis.layer.GCAbstractLayer} source_layers
 * @param {gc.gis.layer.GCGroupLayer} target_layer
 * @param {int} index
 * @return {int} Anzahl der verschobenen Layer
 */
gc.gis.module.GCLayerTree.Panel.prototype.moveLayers = function(source_layers, target_layer, index)
{
    this.module._fireEvent(gc.gis.module.GCLayerTreeEvent.UPDATE_STARTED, {});

    var moved_layers = 0;
    var source_element, target_element, childs;

    if (!Array.isArray(source_layers))
	{
        source_layers = [source_layers];
	}

    target_element = this._getLayerElement(target_layer);

    if (target_element)
    {
        target_element = target_element.children('.item-body').children('.gc-layer-body-content').children('ul.gc-group-items');
    }
    else {
        target_element = this.ul_layer;
    }

    if (target_element)
    {
    	for (var i=0; i<=source_layers.length; i++)
		{
			source_element = this._getLayerElement(source_layers[i]);
			if (source_element)
			{
                childs = target_element.children();

                // Prüfen, ob der Knoten bereits an der richtigen Stelle ist. Dies ist dann der Falle, wenn der Layer per Drag&Drop
                // verschoben wurde. Wird die Move-Methode für Layer applikationsseitig aufgerufen, muss eine Anpassung der Oberfläche erfolgen.
                if (!(childs.length > 0 && jQuery(childs.get(childs.length - index - 1)).is(source_element)))
                {
                    source_element.detach();
                    if (childs.length === 0 || index === 0)
                    {
                        target_element.prepend(source_element);
                    }
                    else {
                        source_element.insertBefore(jQuery(childs.get(childs.length - index)));
                    }
                }
                // else
                // {
                //    gc.gis.iface.log.debug(self, 'Moving layer: GUI do nothing.');
                // }
                moved_layers++;
			}
		}
    }

    this.module._fireEvent(gc.gis.module.GCLayerTreeEvent.UPDATE_FINISHED, {});

    return moved_layers;
};

/**
 * Rendert den Layerbaum komplett neu.
 *
 * @public
 * @method
 */
gc.gis.module.GCLayerTree.Panel.prototype.redrawTree = function()
{
    this.module._fireEvent(gc.gis.module.GCLayerTreeEvent.UPDATE_STARTED, {});

	var self = this;

	// vollständig leeren
	this.clear();

	// Layer rekursiv zufügen
	var layers = self.module.map.getLayers();
	for(var i=0; i<layers.length; i++)
	{
        var element = this._renderLayer(layers[i]);
        this._addLayerElement(layers[i], element);
		this._redrawSubTree(layers[i], element);
	}

	// Drag and Drop initialisieren
	this._initDragAndDrop();

	this.module._fireEvent( gc.gis.module.GCLayerTreeEvent.UPDATE_FINISHED, {} );
};

/**
 * Rendert den Layerbaum für einen Gruppenlayer innerhalb eines Parent-Elements.
 *
 * @param {gc.gis.layer.GCAbstractLayer} layer
 * @param {jQuery} parent_element
 * @private
 * @method
 */
gc.gis.module.GCLayerTree.Panel.prototype._redrawSubTree = function(layer, parent_element)
{
    if(layer instanceof gc.gis.layer.GCGroupLayer)
    {
        var sub_layers = layer.getLayers();
        for(var i=0; i<sub_layers.length; i++)
        {
        	var element = this._renderLayer(sub_layers[i], parent_element);
            this._addLayerElement(sub_layers[i], element);
            this._redrawSubTree(sub_layers[i], element);
        }
    }
};

/**
 * Gibt den Index zu einem Layer innerhalb der internen Liste zurück oder -1, sofern kein Eintrag zum angegebenen Layer
 * gefunden wurde.
 *
 * @param {gc.gis.layer.GCAbstractLayer} layer
 * @return {int}
 * @private
 * @method
 */
gc.gis.module.GCLayerTree.Panel.prototype._getLayerIndex = function(layer)
{
	if (layer) {
        for (var i=0; i < this.layer_elements.length; i++) {
            if (this.layer_elements[i].layer === layer) {
                return i;
            }
        }
    }

    return -1;
};

/**
 * Gibt das jQuery-Element zu einem Layer innerhalb der Baumdarstellung zurück oder <code>null</code>, sofern kein
 * Element zum angegebenen Layer gefunden wurde.
 *
 * @param {gc.gis.layer.GCAbstractLayer} layer
 * @return {jQuery}
 * @private
 * @method
 */
gc.gis.module.GCLayerTree.Panel.prototype._getLayerElement = function(layer)
{
    var idx = this._getLayerIndex(layer);
    if (idx >= 0)
	{
		return this.layer_elements[idx].element;
	}

	return null;
};

/**
 * Fügt einen Layer und das zugehörige Element der internen Liste hinzu und gibt den korrespondierenden Index des
 * Eintrags innerhalb der Liste zurück.
 *
 * @param {gc.gis.layer.GCAbstractLayer} layer
 * @param {jQuery} element
 * @return {int}
 * @private
 * @method
 */
gc.gis.module.GCLayerTree.Panel.prototype._addLayerElement = function(layer, element)
{
    var idx = this.layer_elements.length;
    this.layer_elements.push({
        layer: layer,
        element: element
	});

    return idx;
};

/**
 * Entfernt einen Layer sowie das zugehörige Element von der internen Liste und gibt an, ob ein passender Eintrag
 * gefunden wurde.
 *
 * @param {gc.gis.layer.GCAbstractLayer} layer
 * @return {boolean}
 * @private
 * @method
 */
gc.gis.module.GCLayerTree.Panel.prototype._removeLayerElement = function(layer)
{
    var idx = this._getLayerIndex(layer);
    if (idx >= 0)
    {
        this.layer_elements.splice(idx, 1);

        if(layer instanceof gc.gis.layer.GCGroupLayer)
        {
            var sub_layers = layer.getLayers();
            for(var i=0; i<sub_layers.length; i++ )
            {
                this._removeLayerElement(sub_layers[i]);
            }
        }
        return true;
    }

    return false;
};

/**
 * Initialisiert das Drag and Drop für den Layerbaum.
 *
 * @private
 * @method
 */
gc.gis.module.GCLayerTree.Panel.prototype._initDragAndDrop = function()
{
	var self = this;
    // activate drag-and-drop
    if(this.module.drag_and_drop)
    {
        //jQuery('.gc-group-items').sortable({
        this.element.find('.gc-group-items').sortable({
            appendTo: '.gc-layertree',
            connectWith: '.gc-group-items',
            handle: '.gc-layer-label-text',
            placeholder: 'droppable',
            tolerance: 'pointer',
            // containment: '.gc-group-items',
            distance: 10,
            cursor: 'move',
            // axis: 'y',
            // cursorAt: {top: 16},
            scrollSensitivity: 5,	// default 20
            scrollSpeed: 5,			// default 20
            revert: 200,			// Animationsgeschwindigkeit
            cancel: '',				// macht, dass <button> handle sein kann
            helper: 'clone',		// deaktiviert click-events
            start: function(evt, ui)
            {
                gc.gis.iface.log.debug( self, 'Drag and drop START');
                self.element_content.addClass('drop-active');
                // alten Index ermitteln
                //var selector = 'li.gc-layer:visible, li.gc-layer:hidden';
                var selector = 'li.gc-layer:visible';
                var items = ui.item.parents(selector);

                var old_index = [
                	ui.item.parent().children(selector).length
					- ui.item.index()
					//-1	// muss nicht abgezogen werden, da der zu verschiebende Knoten nicht mehr sichtbar ist (siehe selector)
				];

                for(var i=0; i<items.length; i++)	// ggf. Elterngruppen
                {
                    var idx = [
                        jQuery(items[i]).parent().children( selector ).length
                        - jQuery(items[i]).index()
                        - 1
                    ];
                    old_index = idx.concat(old_index);
                }

                // Index merken
                ui.item.data('__old_index', old_index);
                //ui.item.data('__old_parent', ui.item.parent());

                gc.gis.iface.log.debug(self, 'Moving layer from: ' + old_index.toString());
            },
            stop: function( evt, ui )
            {
                gc.gis.iface.log.debug( self, 'Drag and drop STOP');
                // neuen Index ermitteln
				var i;
                var selector = 'li.gc-layer:visible, li.gc-layer:hidden';
                var items = ui.item.parents(selector);

                var old_index = ui.item.data('__old_index');
                // var old_parent = ui.item.data('__old_parent');

                var new_index = [
                    ui.item.parent().children(selector).length
                    - ui.item.index()
					- 1
				];

                for(i=0; i<items.length; i++)	// ggf. Elterngruppen
                {
                    var idx = [
                        jQuery(items[i]).parent().children(selector).length
                        - jQuery(items[i]).index()
                        - 1
                    ];

                    new_index = idx.concat(new_index);
                }

                //gc.gis.iface.log.debug(self, 'Moving layer to - vorher: ' + new_index.toString());
                if (new_index.length > old_index.length && new_index[old_index.length-1] >= old_index[old_index.length-1])
                {
                    new_index[old_index.length-1]++;
                }

                gc.gis.iface.log.debug(self, 'Moving layer to: ' + new_index.toString());

                // Layer verschieben
                try
                {
                    var lyr = self.module.map.getLayer(old_index);
					self.module.map.moveLayer(lyr, new_index);
                }
                catch(err)
                {
                    gc.gis.iface.log.error(self, err);
                }

                // alten Index vergessen
                ui.item.data('__old_index', undefined);
                //ui.item.data('__old_parent', undefined);
                self.element_content.removeClass('drop-active');
            }
        }).disableSelection();
    }
};

/**
 * Erzeugt einen Item für einem Layer und fügt dieses dem Parent hinzu. Wurde kein Parent angegeben, wird der Layer dem
 * Wurzelelement hinzugefügt und steht damit im Baum auf oberster Ebene.
 * @protected
 * @method
 *
 * @param {gc.gis.layer.GCAbstractLayer} layer
 * @param {jQuery} [parent_element] Referenz auf das Element, zu dem das Layerelement hinzugefügt werden soll,
 * 									erfolgt keine Angabe wird der Layer dem Wurzelelement hinzugefügt
 * @return {jQuery} Referenz auf das erzeugte Element
 */
gc.gis.module.GCLayerTree.Panel.prototype._renderLayer = function(layer, parent_element)
{
	var self = this;

	/* ITEM */
	var li_layer = jQuery('<li>', {
		'class': 'item gc-layer'
			+ (layer.isVisible()  ? ' gc-visible'  : ' gc-invisible')
			+ (layer.isExpanded() ? ' gc-expanded' : ' gc-collapsed')
			+ (layer.isSelected() ? ' gc-selected' : '')
	});

    var ref_scale = this.module.map.getScale();
    if( layer instanceof gc.gis.layer.GCLayer )
    {
    	var ref_scale = this.module.map.getScale();
        if(typeof layer.getMinScale() === 'number' && ref_scale < layer.getMinScale())
        {
        	li_layer.addClass('gc-layer-out-of-scale-range');
        }
        if(typeof layer.getMaxScale() === 'number' && ref_scale > layer.getMaxScale())
        {
            li_layer.addClass('gc-layer-out-of-scale-range');
        }
    }
    li_layer.attr('title', this._getLayerTooltip(layer, ref_scale));

	// Event-Setup
	layer.un( gc.gis.map.GCMapEvent.LAYER_LOADING_ERROR, this );
	layer.on( gc.gis.map.GCMapEvent.LAYER_LOADING_ERROR, this, function(evt ) {
		li_layer.addClass('gc-layertree-status-loading-error');
		li_layer.removeClass('gc-layertree-status-loading');
	});
	layer.un( gc.gis.map.GCMapEvent.LAYER_LOADING_ENDED, this );
	layer.on( gc.gis.map.GCMapEvent.LAYER_LOADING_ENDED, this, function(evt ) {
		li_layer.removeClass('gc-layertree-status-loading');
	});
	layer.un( gc.gis.map.GCMapEvent.LAYER_LOADING_STARTED, this );
	layer.on( gc.gis.map.GCMapEvent.LAYER_LOADING_STARTED, this, function(evt ) {
		li_layer.removeClass('gc-layertree-status-loading-error');
		li_layer.addClass('gc-layertree-status-loading');
	});
	layer.un( gc.gis.layer.GCLayerEvent.EXPANDED_CHANGED, this );
	layer.un( gc.gis.layer.GCLayerEvent.SELECTION_CHANGED, this );
	this.module.map.un( gc.gis.map.GCMapEvent.SCALE_CHANGED, layer );
	this.module.map.on( gc.gis.map.GCMapEvent.SCALE_CHANGED, layer, function(evt )
	{
		if( layer instanceof gc.gis.layer.GCLayer )
		{
			if( typeof layer.getMinScale() === 'number' )
			{
				if(evt.newValue < layer.getMinScale())
				{
                    li_layer.addClass('gc-layer-out-of-scale-range');
				}
				else
				{
                    li_layer.removeClass('gc-layer-out-of-scale-range');
				}
			}
			if( typeof layer.getMaxScale() === 'number' )
			{
				if(evt.newValue > layer.getMaxScale())
				{
                    li_layer.addClass('gc-layer-out-of-scale-range');
				}
				else
				{
                    li_layer.removeClass('gc-layer-out-of-scale-range');
				}
			}

			li_layer.attr('title', self._getLayerTooltip(layer, evt.newValue));
		}
	});

	/* HEAD */
	var item_head = this._renderLayerHead(layer, li_layer);

	/* BODY */
    var item_body = this._renderLayerBody(layer, li_layer);
	if( !layer.isExpanded() )
	{
		li_layer.removeClass('gc-expanded').addClass('gc-collapsed');
		item_body.hide('blind');
	}
	else
	{
		item_body.show('blind');
		li_layer.removeClass('gc-collapsed').addClass('gc-expanded');
	}

	// Head und Body dem Item zufügen
	li_layer.append(item_head).append(item_body);

	/* Listener */
	layer.on( gc.gis.layer.GCLayerEvent.EXPANDED_CHANGED, this, function(evt )
	{
		if( !evt.newValue === true )
		{
			li_layer.removeClass('gc-expanded').addClass('gc-collapsed');
			item_body.hide('blind');
			self._fireEvent( gc.gis.module.GCLayerTreeEvent.TOGGLE_EXPANDED, {} );
		}
		else
		{
			item_body.show('blind');
			li_layer.removeClass('gc-collapsed').addClass('gc-expanded');
			self._fireEvent( gc.gis.module.GCLayerTreeEvent.TOGGLE_EXPANDED, {} );
		}
	} );

	layer.on( gc.gis.layer.GCLayerEvent.SELECTION_CHANGED, this, function(evt )
	{
		if( !evt.newValue === true )
		{
			li_layer.removeClass('gc-selected');
		}
		else
		{
			li_layer.addClass('gc-selected');
		}
		self.module.onToggleSelection( layer );
	});

	// Layer im Tree seinem Parent hinzufügen
	// => prepend verwenden, da Layer intern in umgekehrter Reihenfolge ist, d.h. der erste Layer wird als letztes gerendert
    if (parent_element)
	{
		// parent_element.children('.item-body').children('.gc-layer-body-content').children('ul.gc-group-items').append(li_layer);
        parent_element.children('.item-body').children('.gc-layer-body-content').children('ul.gc-group-items').prepend(li_layer);
    }
    else
    {
        // this.ul_layer.append(li_layer);
        this.ul_layer.prepend(li_layer);
    }

	return li_layer;
};

/**
 * @protected
 * @method
 *
 * @param {gc.gis.layer.GCAbstractLayer} layer
 * @param {jQuery} element Referenz auf das Layer-Element <code>&lt;li&gt;</code>
 * @return {jQuery}
 */
gc.gis.module.GCLayerTree.Panel.prototype._renderLayerHead = function(layer, element)
{
	/* Toggle expand */
	var cssClass = 'gc-layer-action gc-layer-action-expand',
		label = '',
		withLegend = layer instanceof gc.gis.layer.GCLayer && layer.getShowLegend();

	if (layer instanceof gc.gis.layer.GCGroupLayer)
	{
        //cssClass += ' gc-layer-group ms';
		cssClass += ' gc-layer-group icon';
		label = 'Gruppe auf-/zuklappen';
	}
	else
	{
		cssClass += ' gc-layer-leaf';
		if (withLegend)
		{
			cssClass += ' legend';
			label = 'Legende auf-/zuklappen';
		}
		else
		{
			label = 'keine Legende verfügbar';
		}
		//cssClass += ' ms';
		cssClass += ' icon';
	}
	var item_toggle_expand_btn = new gc.gis.widget.GCItem({
        className: cssClass,
		icon: '',
		title: label,
		label: label,
		tooltip: label,
		action: new gc.gis.action.layer.ToggleExpansion({layer: layer})
	});

	var item_toggle_expand = jQuery('<div>', {
		'class': 'gc-layer-toggle-expand'
	});
	item_toggle_expand.append( item_toggle_expand_btn.getElement() );

	/* Label */
	var select_action = new gc.gis.action.layer.ToggleSelection({layer: layer});
	var item_label_text = jQuery('<button>', {
		'class': 'gc-layer-label-text',
		html: '<span>'+ layer.getLabel() +'</span>',
		click: function(evt) {
			select_action.execute(this);
		}
	});
	layer.un( gc.gis.layer.GCLayerEvent.LABEL_CHANGED, this );
	layer.on( gc.gis.layer.GCLayerEvent.LABEL_CHANGED, this, function(evt ) {
		item_label_text.html('<span>'+ layer.getLabel() +'</span>');
	});

	var item_label = jQuery('<div>', {
		'class': 'gc-layer-label'
	});
	item_label.append(item_label_text);

	//var item_label = jQuery('<div>', {
	//	'class': 'gc-layer-label-container'
	//});
	//item_label.append( item_toggle_expand ).append( item_label_text );

	/* Aktionen */
	var item_actions = this._renderLayerActions( layer, element );

	/* Container */
	var head = jQuery('<div>', {
		'class': 'gc-layer-head'
	});
	head.append( item_toggle_expand ).append( item_label ).append( item_actions );

	return head;
};

/**
 * @protected
 * @method
 *
 * @param {gc.gis.layer.GCAbstractLayer} layer
 * @param {jQuery} element Referenz auf das Layer-Element <code>&lt;li&gt;</code>
 * @return {jQuery}
 */
gc.gis.module.GCLayerTree.Panel.prototype._renderLayerBody = function(layer, element)
{
    var self = this;

    var item_body = jQuery('<div>', {
        'class': 'item-body'
    });
    var body_content = jQuery('<div>', {
        'class': 'gc-layer-body-content'
    });

	// Gruppen-Layer
    if(layer instanceof gc.gis.layer.GCGroupLayer)
    {
        var emtpy_content = jQuery('<p>', {
        	'class': 'gc-empty',
        	html: '<em>Leere Gruppe</em>'
		});
        var ul = jQuery('<ul>', {
            'class': 'gc-group-items'
        });

        //body_content.append(emtpy_content).append(ul);
	    body_content.append(ul).append(emtpy_content);
    }
    // Layer
    else if(layer instanceof gc.gis.layer.GCLayer)
    {
        // ggf. Legende anzeigen
        if(layer.getShowLegend())
        {
            var div_legend = jQuery('<div>', {
                'class': 'gc-layer-property gc-layer-legend'
            });
            body_content.append(div_legend);

            if(layer.isExpanded())
            {
                self._renderLegendBody(layer, div_legend);
            }

            layer.on(gc.gis.layer.GCLayerEvent.EXPANDED_CHANGED, this, function(evt) {
                if(evt.newValue === true)
                {
                    self._renderLegendBody(layer, div_legend);
                }
            });
        }
    }

    item_body.append(body_content);

    return item_body;
};

/**
 * @param {gc.gis.layer.GCAbstractLayer} layer
 * @param {jQuery} element Referenz auf das Layer-Property-Element der Legende
 * 							(Selector .gc-layer-property .gc-layer-legend)
 * @private
 */
gc.gis.module.GCLayerTree.Panel.prototype._renderLegendBody = function(layer, element)
{
    element.children().remove();

    var lbl_legend = jQuery('<label>', {text: 'Legende:'});
    element.append(lbl_legend).append(this.module.createLegendElement(layer));
};

/**
 * Verarbeitet die Hooks, die fremden Modulen das einklinken in die
 * Layeraktionen ermöglichen.
 *
 * @protected
 * @method
 *
 * @param {gc.gis.module.GCLayerTreeActionHook[]} hooks Hooks
 * @param {Object} options Optionen für den Aufruf der Hook-Callbacks
 */
gc.gis.module.GCLayerTree.Panel.prototype._createLayerActionHookWidgets = function( hooks, options )
{
	var self = this;

	var widgets = [];

	if( hooks )
	{
		for( var i=0; i<hooks.length; i++ )
		{
			try
			{
				(function( hook ) {
					var widget = hook.initFunc.call( self, options );
					if( widget )
					{
						// Widget merken
						widgets.push( widget );
						options.widget = widget;

						// Beim Rendern muss das Widget neu initialisiert werden
						self.module.on( gc.gis.module.GCLayerTreeEvent.UPDATE_STARTED, widget, function( evt ) {
							hook.destroyFunc.call( self, options );
						});
					}
					return widget;
				})( hooks[i] );
			}
			catch( err )
			{
				gc.gis.iface.log.error( this, err );
				// gc.gis.iface.log.error( this, new gc.gis.error.GCError('Failed to attach hooked action', err ) );
			}
		}
	}

	return widgets;
};

/**
 * @protected
 * @method
 *
 * @param {gc.gis.layer.GCAbstractLayer} layer
 * @param {jQuery} element Referenz auf das Layer-<code>&lt;li&gt;</code>
 */
gc.gis.module.GCLayerTree.Panel.prototype._renderLayerActions = function( layer, element )
{
	var self = this;
	//////// MENÜ ////////

	/* Deckkraft slider */
	var widget_opacity = new gc.gis.widget.GCSlider({
		label: 'Deckkraft:',
		className: 'gc-layer-action-opacity',
		value: layer.getOpacity()*100,
		min: 0,
		max: 100,
		step: 1,
		unit: '%',
		callback: function( value ) {
			layer.setOpacity( value/100 );
		}
	});

	layer.un( gc.gis.layer.GCLayerEvent.OPACITY_CHANGED, this );
	layer.on( gc.gis.layer.GCLayerEvent.OPACITY_CHANGED, this, function(evt ) {
		widget_opacity.setValue( evt.newValue*100 );
	});

	/* Allgemeine Aktionen */
	var actions_common = [
		new gc.gis.widget.GCItem({
			label: 'Auf Ebene zoomen',
			action: new gc.gis.action.layer.FitExtent({
				layer: layer
			})
		}),
		new gc.gis.widget.GCItem({
			label: 'Ebene umbenennen',
			action: new gc.gis.action.layer.RenameLayer({
				layer: layer
			})
		}),
		new gc.gis.widget.GCItem({
			label: 'Ebene entfernen',
			action: new gc.gis.action.layer.RemoveLayer({
				layer: layer
			})
		}),
		widget_opacity
	];
	if( layer instanceof gc.gis.layer.GCLayer )
	{
		actions_common.push( new gc.gis.widget.GCItem({
			label: 'Ebeneninformationen anzeigen',
			action: new gc.gis.action.layer.ShowLayerInfo({
				layer: layer
			})
		}) );
	}
	// Extern eingebundene
	actions_common = actions_common.concat( this._createLayerActionHookWidgets(
		this.module.getHooks( gc.gis.module.GCLayerTreeActionHook.LAYER_COMMON_ACTION ),
		{layer: layer}
	) );

	var actions_specific = [];

	/* Layertyp-spezifische Aktionen */
	if( layer instanceof gc.gis.layer.GCGroupLayer )
	{
		// dissolve group
		actions_specific.push( new gc.gis.widget.GCItem({
			label: 'Gruppe auflösen',
			action: new gc.gis.action.layer.DissolveGroup({
				group: layer/*,
				'parent': layer.getParent()*/
			})
		}) );

		actions_specific = actions_specific.concat( this._createLayerActionHookWidgets(
			this.module.getHooks( gc.gis.module.GCLayerTreeActionHook.LAYER_GROUP_ACTION ),
			{layer: layer}
		) );
	}
	else if( layer instanceof gc.gis.layer.GCVectorLayer )
	{
/*		// de-/select features	// FIXME
		actions_specific.push( new gc.gis.widget.GCItem({
			label: 'Featureauswahl aufheben',
			action: new gc.gis.action.layer.DeselectFeatures({
				layer: layer
			})
		}) );
		// attribute table	// FIXME
		actions_specific.push( new gc.gis.widget.GCItem({
			label: 'Attributtabelle anzeigen',
			action: new gc.gis.action.layer.ShowAttributeTable({
				layer: layer
			})
		}) );*/
		actions_specific = actions_specific.concat( this._createLayerActionHookWidgets(
			this.module.getHooks( gc.gis.module.GCLayerTreeActionHook.LAYER_VECTOR_ACTION ),
			{layer: layer}
		) );
	}
	else if( layer instanceof gc.gis.layer.GCRasterLayer )
	{
		// hmm?
		actions_specific = actions_specific.concat( this._createLayerActionHookWidgets(
			this.module.getHooks( gc.gis.module.GCLayerTreeActionHook.LAYER_RASTER_ACTION ),
			{layer: layer}
		) );
	}

	var actions = [];
    actions.push(actions_common);
	if(actions_specific.length > 0)
	{
		actions.push(actions_specific);
	}

	// layerspezifische Aktionen, die serverseitig vorgegeben wurden, z.B. "Fachdaten öffnen"
	var serversideActions = layer.getActions();
	if (serversideActions.length > 0)
	{
		var serversideActionsItems = [];
		for (var i=0; i<serversideActions.length; i++)
		{
			serversideActionsItems.push(
				new gc.gis.widget.GCItem({
					label: serversideActions[i].caption,
					action: gc.gis.action.GCServerSideActionFactory.createAction(serversideActions[i])
				})
			);
		}
		actions.push(serversideActionsItems);
	}

	// Sichtbarkeitsfeedback
	layer.un( gc.gis.layer.GCLayerEvent.VISIBILITY_CHANGED, this );
	layer.on( gc.gis.layer.GCLayerEvent.VISIBILITY_CHANGED, this, function(evt ) {
		var was_visible = evt.oldValue;
		var is_visible  = evt.newValue;
		if( was_visible && !is_visible )
		{
			element.removeClass('gc-visible').addClass('gc-invisible');
			self._fireEvent( gc.gis.module.GCLayerTreeEvent.TOGGLE_VISIBILITY, {} );
		}
		else if( !was_visible && is_visible )
		{
			element.removeClass('gc-invisible').addClass('gc-visible');
			self._fireEvent( gc.gis.module.GCLayerTreeEvent.TOGGLE_VISIBILITY, {} );
		}
	} );

	//////// CONTAINER ////////
	var item_actions = new gc.gis.widget.GCWidgetGroup({
		containerClassName: 'gc-layer-actiongroup',
		items: [
			new gc.gis.widget.GCMenu({
				label: 'Aktionen',
				tooltip: 'Ebenen-Aktionen',
				className: 'gc-layer-action',
				direction: 'right',
				icon: 'glyphicon glyphicon-option-vertical gc-layer-action-more',
				containerClassName: 'gc-layertree-actionmenu gc-layertree-menu-layer',
				items: actions
			}),
			new gc.gis.widget.GCToggleItem({
				label: 'Ebene anzeigen/verstecken',
				tooltip: 'Ebene anzeigen/verstecken',
				className: 'gc-layer-action',
				icon: 'glyphicon gc-layer-action-visibility',
				active: layer.isVisible(),
				action: new gc.gis.action.layer.ToggleVisibility({layer: layer})
			})
		]
	});
	return item_actions.getElement();
};

/**
 * @protected
 * @method
 *
 * @param {gc.gis.layer.GCAbstractLayer} layer Layer
 * @param {int} scale aktueller Maßstab
 */
gc.gis.module.GCLayerTree.Panel.prototype._getLayerTooltip = function(layer, scale)
{
    var title = '';

    if( layer instanceof gc.gis.layer.GCLayer )
    {
        title += 'Ebene ' + layer.getLabel();

        var scale_info = '';
        if (typeof layer.getMinScale() === 'number')
		{
			scale_info += 'ab 1:' + (layer.getMinScale()).toLocaleString();
		}
        if (typeof layer.getMaxScale() === 'number')
        {
            scale_info += ' bis 1:' + (layer.getMaxScale()).toLocaleString();
        }

        if (typeof scale === 'number')
		{
            if (typeof layer.getMinScale() === 'number' && scale < layer.getMinScale()
				|| typeof layer.getMinScale() === 'number' && scale > layer.getMaxScale())
			{
				title += ' wird bei aktuellem Maßstab nicht angezeigt';
			}
		}

		if (scale_info)
		{
            title += ' (sichtbar ' + scale_info.trim() + ')';
        }
    }
    else
    {
        title += 'Gruppe ' + layer.getLabel();
    }

	return title;
};
